import ChangeLicenseCountModal from './ChangeLicenseCountModal.js';
import DeactivateDevicesModalViewModel from './DeactivateDevicesModalViewModel.js';
import ConfirmSubscriptionModal from './ConfirmSubscriptionModal.js';
import { ToastMessage } from '../../components/ToastMessage/ToastMessage.js';

const ChangeCountManagerModal = (
    { 
        currentStep,
        toast,
        isLoading,
        isOpen,
        closeModel,
        changeCount,
        newLicenseCount,
        setNewLicenseCount,
        devicesSet,
        saveSubscription,
        currentLicenseCount,
        setSubscriptionDevices,
        subscriptionDevices,
        toastToggleCallback
    }
) => {
    
    return (
        <>
            {toast?.display && (
                <ToastMessage Message={toast?.message} ToggleCallback={toastToggleCallback} Type={toast?.type} />

            )}
            <ChangeLicenseCountModal
                isOpen={isOpen && currentStep == steps.ChangeCount}
                isLoading={isLoading}
                size="md"
                handleClose={closeModel}
                currentLicenseCount={currentLicenseCount}
                newLicenseCount={newLicenseCount}
                setNewLicenseCount={setNewLicenseCount}
                submitHandler={changeCount}
            />
            <DeactivateDevicesModalViewModel
                isOpen={isOpen && currentStep == steps.Deactivate}
                isLoading={isLoading}
                size="md"
                handleClose={closeModel}
                currentLicenseCount={currentLicenseCount}
                newLicenseCount={newLicenseCount}
                setCurrentLicenseCount={setNewLicenseCount}
                submitHandler={devicesSet}
                devices={subscriptionDevices}
                setDevices={setSubscriptionDevices}
            />
            <ConfirmSubscriptionModal
                isOpen={isOpen && currentStep == steps.Confirm}
                isLoading={isLoading}
                size="md"
                handleClose={closeModel}
                currentLicenseCount={currentLicenseCount}
                newLicenseCount={newLicenseCount}
                submitHandler={saveSubscription}
            />

        </>

    );
}

const steps = {
    ChangeCount: 0,
    Deactivate: 1,
    Confirm: 2
}

export { ChangeCountManagerModal, steps };